import { ArchiveBoxArrowDownIcon, ArchiveBoxXMarkIcon, TrashIcon } from '@heroicons/react/24/outline'
import { PencilIcon } from '@heroicons/react/24/solid'

const EditButtons = ({
  contactId, isArchived, isPendingAction, 
  handleEditClick, handleArchiveClick, handleDeleteClick
}) => {
  return (
    <div>
      <button 
        className="btn btn-sm btn-ghost btn-square hover:bg-primary-400" 
        title="Modifier le contact"
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          handleEditClick(contactId)
        }}
      >
        <PencilIcon className="h-5 w-5" />
      </button>
      <button 
        id='archiveBtn' 
        className={`btn btn-sm btn-ghost btn-square hover:bg-primary-400 ${
          isPendingAction ? 'loading' : ''
        }`} 
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          if (!isPendingAction) {
            handleArchiveClick(contactId)
          }
        }}
        disabled={isPendingAction}
        title={`${isArchived ? "Restaurer" : "Archiver"} le contact`}
      >
        {!isPendingAction && (
          isArchived ? <ArchiveBoxXMarkIcon className="h-5 w-5" /> : <ArchiveBoxArrowDownIcon className="h-5 w-5" />
        )}
      </button>
      { !isPendingAction && !!isArchived && handleDeleteClick && (
          <button 
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              handleDeleteClick()
            }} 
            title="Supprimer le bien"
            className="p-1 btn btn-sm btn-ghost btn-square hover:bg-primary-400">
            <TrashIcon className="h-5 w-5" />
          </button>
        )}
    </div>
  )
}

export default EditButtons